module.exports = __webpack_public_path__ + "img/doc.d90fa931.png";